export {};

declare global {
  interface Window {
    Tawk_API?: {
      visitor?: {
        name: string;
        email: string;
      };
    };
  }
}

import { RootState } from '@/store/store';
import { useSelector } from 'react-redux';
import SafeTawkMessenger from './SafeTawkMessenger';

const TawkIntegration = () => {
  const user = useSelector((state: RootState) => state.user);
  const propertyId = import.meta.env.VITE_TAWK_PROPERTY_ID;
  const widgetId = import.meta.env.VITE_TAWK_WIDGET_ID;

  if (!propertyId || !widgetId) {
    console.error('Tawk.to property or widget ID is missing in the environment variables.');
    return null;
  }

  if (typeof window !== 'undefined' && user) {
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_API.visitor = {
      name: user.name,
      email: user.email,
    };
  }

  return (
    <SafeTawkMessenger
      propertyId={propertyId}
      widgetId={widgetId}
      // Example: override specific handler
      onLoad={() => console.log('Tawk loaded')}
    />
  );
};

export default TawkIntegration;
